import React, { FC, useEffect, useState, useContext } from 'react';
import {
  Grid,
  Container,
  Typography,
  Button,
  Tooltip,
  makeStyles,
  Theme,
  useTheme,
  Drawer,
  useMediaQuery,
  IconButton,
  InputBase,
  Paper,
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  useScrollTrigger,
  Zoom
} from '@material-ui/core';
import {
  AddBox,
  AddShoppingCartRounded,
  ArrowBackRounded,
  ArrowUpwardRounded,
  ClearRounded,
  Description,
  ExitToApp,
  ExitToAppRounded,
  PersonRounded,
  Refresh,
  ShoppingCartRounded,
  Today,
  TuneRounded
} from '@material-ui/icons';
import { Page, StandardConfirmationDialog, Breadcrumb, PaperCustom, FormPinDialog } from 'components';
import {
  SALES_ORDER_BASE_URL,
  SALES_ORDER_LIST_BASE_URL,
  SALES_ORDER_EXPORT_BASE_URL,
  SET_ISOPEN_SO,
  ZONE_BASE_URL,
  GET_NOTIF_DISCOUNT,
  SALES_BASE_URL,
  LOGOUT_URL
} from 'constants/url';
import axios, { CancelTokenSource } from 'axios';
import SalesOrderTable from './components/SalesOrderTable';
import Pagination from '@material-ui/lab/Pagination';
import useRouter from 'hooks/useRouter';
import useRole from 'hooks/useRole';

import useConfirmationPin from 'hooks/useConfirmationPin';
import { CurrentUserContext } from 'contexts/CurrentUserContext';
import { CartContext } from 'contexts/CartContext';
import { format, startOfMonth } from 'date-fns';
import { dummyCurrentUser, dummyMetaData, dummyZone } from 'utils/dummy';
import { BACKGROUND, BLACK, GREEN, GREEN_MOBILE, GREY, BLUE_PRIMARY, WHITE } from 'constants/colors';
import RefreshIcon from '@material-ui/icons/Refresh';
import ExportModal from './components/ExportModal';
import useDebounced from 'hooks/useDebounced';
import TypeUser from 'typings/enum/TypeUser';
import ItemStatus from 'typings/enum/ItemStatus';
import CardTotal from './components/CardTotal';
import Search from '@material-ui/icons/Search';
import CardMobile from './components/CardMobile';
import DrawerFilter from './components/DrawerFilter';
import ImageModal from 'components/ImageModal';
import DateRangeFilter from 'components/DateRangeFilter';
import { Skeleton } from '@material-ui/lab';
import SalesOrderStatus from 'typings/enum/SalesOrderStatus';
import ModalDiscount from './components/ModalDiscount';
import AuthorisationList from './components/AuthorisationList';
import NumberFormat from 'components/NumberFormat';
import UpdateProfileModal from 'components/ProfileModal/UpdateProfileModal';
import { getCurrentUserId } from 'selectors';
import clsx from 'clsx';
import PaginationCustom from 'components/PaginationCustom';

const useStyles = makeStyles((theme: Theme) => ({
  refresh: {
    backgroundColor: GREEN,
    color: WHITE,
    '&:hover': {
      backgroundColor: GREEN
    }
  },

  mobile: {
    [theme.breakpoints.up('md')]: {
      display: ' none'
    }
  },
  desktop: {
    [theme.breakpoints.down('md')]: {
      display: ' none'
    }
  },
  containerMobile: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1)
  },

  textHeaderMobile: {
    fontSize: '1.2rem',
    color: BLACK,
    fontWeight: 500
  },
  textContentMobile: {
    fontSize: '0.875rem'
  },
  textContentBoldMobile: {
    fontSize: '0.875rem',
    fontWeight: 500
  },
  iconRefreshButton: {
    width: '44px',
    height: '25px',
    backgroundColor: GREEN_MOBILE,
    display: 'grid',
    placeItems: 'center',
    marginRight: theme.spacing(1),
    borderRadius: '5px',
    color: WHITE,
    '&:active': {
      animation: `$zoom 450ms ease`
    }
  },
  searchingContainer: {
    marginTop: theme.spacing(1),
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: '5px'
  },
  iconButton: {
    color: '#616161'
  },
  iconSearchButton: {
    padding: '.5em',
    width: '2em'
  },
  containerAutoratation: {
    marginTop: '1em',
    border: '1.5px solid #02A9EA',
    backgroundColor: '#fff',
    borderRadius: '5px'
  },
  sectionContentMobile: {
    paddingTop: theme.spacing(1),
    minHeight: '50vh'
  },
  AddShoppingCartIcon: {
    color: '#fff'
  },
  AddShoppingCartWrapper: {
    position: 'fixed',
    background: BLUE_PRIMARY,
    borderRadius: '50%',
    display: 'grid',
    padding: '.7em',
    opacity: 0.9,
    placeItems: 'center',
    border: `1px solid #fff`,
    boxShadow: '0px 3px 3px -1px rgb(0 0 0 / 50%)',
    right: 10,
    bottom: 20,
    zIndex: 1
  },
  ArrowUp: {
    position: 'fixed',
    background: 'hsl(216, 45%, 98%, 0.8)',
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    border: `1px solid ${GREY}`,
    padding: '.6em',
    boxShadow: '0px 3px 3px -1px rgb(0 0 0 / 50%)',
    right: 20,
    zIndex: 1
  },
  '@keyframes zoom': {
    from: {
      transform: 'scale(1)'
    },
    to: {
      transform: 'scale(.5)'
    }
  },
  containerNotification: {
    position: 'relative',
    display: 'grid',
    placeItems: 'center'
  },
  buttonBack: {
    transform: `rotate(-180deg)`
  },
  cardContainer: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: '#9F9F9F',
    width: '160px',
    height: '83px',
    right: 0,
    top: 45,
    borderRadius: 5,
    padding: '15px'
  },

  animationNotif: {
    animation: `$buttonNotifAnimation 2s infinite`
  },

  '@keyframes buttonNotifAnimation': {
    '0%': {
      transform: 'rotate(10deg)'
    },

    '10%': {
      transform: 'rotate(-10deg)'
    },
    '15%': {
      transform: 'rotate(10deg)'
    },
    '20%': {
      transform: 'rotate(-10deg)'
    },
    '25%': {
      transform: 'rotate(10deg)'
    },
    '30%': {
      transform: 'rotate(0deg)'
    }
  },
  cardChild: {
    position: 'absolute',
    backgroundColor: '#9F9F9F',
    width: '15px',
    height: '15px',
    right: 8,
    top: 40,
    transform: 'rotate(130deg)'
  },
  spacing: {
    margin: '0.5em 0'
  },
  containerBox: {
    marginTop: '0.8em',
    marginBottom: '0.3em',
    gap: '0.6em'
  },

  containerBoxItem: {
    flex: 0.5,
    borderRadius: '5px',
    backgroundColor: '#fff',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.07)',
    padding: '14px'
  },

  wrapperMobile: {
    backgroundColor: 'transparent',
    marginTop: theme.spacing(2)
  },

  navigationWrapper: {
    minHeight: '4em'
  },
  inputContainer: {
    backgroundColor: GREY,
    borderRadius: '.4em',
    paddingLeft: '.7em',
    transition: 'all .3s ease-in-out'
  },
  boxShadow: {
    boxShadow: '0px 3px 3px -1px rgb(0 0 0 / 30%)'
  },

  wrapperSearchFocus: {
    maxWidth: '93%',
    background: BACKGROUND,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    columnGap: '1em',
    top: '.65em',
    left: '.9em',
    right: '.8em',
    zIndex: 1
  },

  topHeader: {
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    padding: '0 1em'
  },
  logo: {
    objectFit: 'contain',
    height: '20px',
    '& > *': {
      color: 'red'
    }
  },
  buttomNavigation: {
    position: 'fixed',
    boxShadow: '0px -2px 2px -1px rgb(0 0 0 / 30%)',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2
  }
}));

const SalesOrderPage: FC = () => {
  const classes = useStyles();
  const { history } = useRouter();

  const theme = useTheme();
  const showComponent = useMediaQuery(theme.breakpoints.down('md'));

  const { unsetCurrentUser, currentUser } = useContext(CurrentUserContext);
  const isAccess = (currentUser && currentUser.type) || TypeUser.PICKER;
  console.log('isAccess -->', isAccess);
  const getWareHouse: any = (currentUser && currentUser.WareHouseId) || 0;

  const { setCart } = useContext(CartContext);
  const [idClick, setIdClick] = useState<number>(0);

  const [count, setCount] = useState<number>(0);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [salesOrders, setSalesOrders] = useState<SalesOrderModel[]>([]);
  const [totalAuthorization, setTotalAuthorization] = useState<number>(0);
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = useState<string>('id');
  const [authorizaion, setAuthorizaion] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [confirmationDelete, setConfirmationDelete] = useState<boolean>(false);
  const [snackbarVariant, setSnackbarVariant] = useState<'success' | 'error'>('success');
  const [message, setMessage] = useState<string>('');
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [salesName, setSalesName] = useState<string>('');
  const [salesNameTemp, setSalesNameTemp] = useState('');
  const [salesOrderId, setSalesOrderId] = useState<string>('');
  const [statusOrder, setStatusOrder] = useState<string>('PENDING');
  const [hasFilter, setHasFilter] = React.useState<string>('PENDING');
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [isSearchFocus, setIsSearchFocus] = useState<boolean>(false);
  const [pin, setPin] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<string>(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState<string>(format(new Date(), 'yyyy-MM-dd'));
  const [openCalendarFilter, setOpenCalendarFilter] = useState<boolean>(false);
  const [isComplete, setComplete] = useState<boolean>(false);
  const [openCollapse, setOpenCollapse] = useState<boolean>(false);
  const [isShown, setIsShown] = useState<boolean>(false);
  const [indexCollapse, setIndexCollapse] = useState<number>(-1);
  const [search, setSearch] = useState<string>('');
  const [discountResource, setDiscountResource] = useState<{ productName: string; totalQty: number; discount: number; totalDiscount: number }>({
    productName: '',
    totalQty: 0,
    discount: 0,
    totalDiscount: 0
  });
  const [totalNominal, setTotalNominal] = useState<{ totalSo: number; totalSoTerkonfirmasi: number; totalSoTertunda: number }>({
    totalSo: 0,
    totalSoTerkonfirmasi: 0,
    totalSoTertunda: 0
  });
  const [snackbarVarient, setSnackbarVarient] = useState<'success' | 'error'>('success');
  const [openImage, setOpenImage] = useState<boolean>(false);
  const [imagePath, setImagePath] = useState<string>('');
  const [total, setTotal] = useState<number>(0);
  const [to, setTo] = useState<number>(0);
  const [from, setFrom] = useState<number>(0);
  const [loadingItem, setLoadingItem] = useState<boolean>(false);
  const [zone, setZone] = useState<number[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<number[]>([]);
  const [zones, setZones] = useState<ZoneModel[]>([dummyZone]);
  const [isDrawerFilter, setIsDrawerFilter] = useState<boolean>(false);
  const [showAuthorisation, setShowAuthorisation] = useState<boolean>(false);
  const [authorisations, setAuthorisations] = useState<Authorisation[]>([]);
  const [loadingAuthorisation, setLoadingAuthorisation] = useState<boolean>(false);
  const [metaAuthorisation, setMetaAuthorisation] = useState<MetaData>(dummyMetaData);
  const [keywordAuthorisation, setKeywordAuthorisation] = useState<string>('');
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [user, setUser] = useState(currentUser);
  const [currentEditingUserProfileId, setCurrentEditingUserProfileId] = useState<number>(0);
  const [openProfileModal, setOpenProfileModal] = useState<boolean>(false);
  const [openLogout, setLogout] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const trigger = useScrollTrigger({
    target: window,
    disableHysteresis: true,
    threshold: 200
  });

  const { firstName, isNew, type } = currentUser ? currentUser : dummyCurrentUser;
  const isAddAllowed = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SUPERADMIN, TypeUser.ADMIN, TypeUser.SALES, TypeUser.SUPERVISOR, TypeUser.HEAD_ADMIN_OPS]
  });

  const userProfileId = getCurrentUserId(currentUser);
  const isExportAllowed = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SUPERADMIN, TypeUser.SALES]
  });
  const isShow = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.PICKER, TypeUser.ADMIN01, TypeUser.ADMIN02]
  });

  const isSuperVisor = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SUPERVISOR]
  });

  const isSuperAdmin = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SUPERADMIN]
  });
  const isAdmin = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.ADMIN]
  });

  const isSales = useRole({
    type: (currentUser && currentUser.type) || TypeUser.SALES,
    allowed: [TypeUser.SALES]
  });

  const allowAuthorisation: string[] = [TypeUser.SALES, TypeUser.SUPERVISOR, TypeUser.PICKER];

  const salesRoute = currentUser && currentUser.SalesRoute ? currentUser.SalesRoute.map(value => value.ZoneId) : [];
  let cancelToken: CancelTokenSource = axios.CancelToken.source();

  const [openExport, setOpenExport] = useState<boolean>(false);
  const [date, setDate] = useState<string>('');
  const [dateStart, setDateStart] = useState<string>('');
  const [dateEnd, setDateEnd] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [zoneExport, setZoneExport] = useState<number[]>([]);

  const handleCalendarFilterClick = () => setOpenCalendarFilter(!openCalendarFilter);

  const pinMessage = useConfirmationPin({
    pin,
    confirmationDelete: confirmationDelete,
    isCompletePin: isComplete,
    handleOnDelete: deleteSalesOrder,
    setOpenConfirmation: setOpenConfirmation,
    setLoading: setLoadingDelete,
    setCompletePin: setComplete,
    setPin: setPin
  });

  const fetchData = async () => {
    setIsLoadingData(true);

    const getQueryParams = () => {
      const params = new URLSearchParams();

      if (name) {
        params.append('partner', name);
      }

      if (salesOrderId) {
        params.append('keyword', salesOrderId);
      }

      if (salesName) {
        params.append('sales', salesName);
      }

      if (isSales) {
        if (currentUser) {
          params.append('SalesId', currentUser.id.toString());
        }
      }

      if (isSuperVisor || isSales) {
        if (currentUser) {
          params.append('Zone', (currentUser.SalesRoute && currentUser.SalesRoute.map(value => value.ZoneId).join(',')) || '');
        }
      }

      if (zone.length > 0) {
        params.append('Zone', zone.join(',') || '');
      }

      if (!authorizaion && (isSuperAdmin || isAdmin)) {
        params.append('startDate', startDate);
        params.append('endDate', endDate);
      }

      if (authorizaion) {
        params.append('authorization', 'True');
      }
      params.append('statusOrder', statusOrder);
      params.append('page', currentPage.toString());
      params.append('orderBy', orderBy);
      params.append('ordered', order);
      return params.toString();
    };

    try {
      const { data } = await axios.get(`${SALES_ORDER_LIST_BASE_URL}?${getQueryParams()}`, { cancelToken: cancelToken.token });
      setSalesOrders(data.data);

      setCount(data.meta.last_page);
      setTotal(data.meta.total);
      setTo(data.meta.to);
      setFrom(data.meta.from);
    } catch (error) {
      console.log('error: ', error);
    } finally {
      setIsLoadingData(false);
    }
  };

  const fetchTotalNominal = async () => {
    const getQueryParams = () => {
      const params = new URLSearchParams();

      if (name) {
        params.append('partner', name);
      }

      if (salesOrderId) {
        params.append('keyword', salesOrderId);
      }

      if (salesName) {
        params.append('sales', salesName);
      }

      if (isSales) {
        if (currentUser) {
          params.append('SalesId', currentUser.id.toString());
        }
      }

      if (isSuperVisor || isSales) {
        if (currentUser) {
          params.append('Zone', (currentUser.SalesRoute && currentUser.SalesRoute.map(value => value.ZoneId).join(',')) || '');
        }
      }

      if (zone.length > 0) {
        params.append('Zone', zone.join(',') || '');
      }

      if (!authorizaion && (isSuperAdmin || isAdmin)) {
        params.append('startDate', startDate);
        params.append('endDate', endDate);
      }

      if (authorizaion) {
        params.append('authorization', 'True');
      }

      params.append('statusOrder', statusOrder);
      params.append('page', currentPage.toString());
      params.append('orderBy', orderBy);
      params.append('ordered', order);

      return params.toString();
    };

    try {
      const dataTotalNominal = await axios.get(`${SALES_ORDER_BASE_URL}/totalNominal?${getQueryParams()}`, { cancelToken: cancelToken.token });
      setTotalNominal(dataTotalNominal.data);
    } catch (error) {
      console.log('error: ', error);
    }
  };

  const handleSearchAuthorisation = () => {
    fecthDataAuthorisations();
  };
  const fecthDataAuthorisations = async () => {
    setLoadingAuthorisation(true);
    const getQueryParams = () => {
      const params = new URLSearchParams();
      if (keywordAuthorisation) {
        if (/\d/.test(keywordAuthorisation)) {
          if (keywordAuthorisation.search('#') > -1) {
            params.append('keyword', keywordAuthorisation.substring(1));
          } else {
            params.append('keyword', keywordAuthorisation);
          }
        } else {
          params.append('partner', keywordAuthorisation);
        }
      }
      params.append('authorization', 'True');
      return params;
    };

    try {
      const { data } = await axios.get(`${SALES_ORDER_LIST_BASE_URL}?${getQueryParams()}`);
      setAuthorisations(data.data);
      setMetaAuthorisation(data.meta);
      setLoadingAuthorisation(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (allowAuthorisation.includes(isAccess)) {
      fecthDataAuthorisations();
    }
  }, [showAuthorisation]);
  const handleCancelProfileModal = () => {
    setOpenProfileModal(false);
  };
  const handleOpenSO = async (id: number) => {
    if (isAccess !== TypeUser.SALES && isAccess !== TypeUser.SUPERVISOR && isAccess !== TypeUser.ADMIN02 && isAccess !== TypeUser.ADMIN02PLUS) return;
    try {
      await axios.get(`${SET_ISOPEN_SO(id)}`);
      history.push(`/penjualan/${id}`);
    } catch (error) {
      console.log(error);
    }
  };

  const fecthZone = async () => {
    const params = new URLSearchParams();
    params.append('route', salesRoute.join(','));
    params.append('orderBy', 'name');
    params.append('ordered', 'asc');
    params.append('perPage', '1000');
    try {
      const { data } = await axios.get(`${ZONE_BASE_URL}?${params.toString()}`);
      setZones(data.data);
    } catch (error) {
      console.log('error :', error);
    } finally {
    }
  };

  const handleSnackBar = (open: boolean, variant: 'success' | 'error', message: string): void => {
    setSnackbarVariant(variant);
    setOpenSnackbar(open);
    setMessage(message);
  };

  const handleConfirmationDelete = (id: number): React.MouseEventHandler => () => {
    setSelectedId(id);
    setConfirmationDelete(true);
  };

  const handleOpenImage = (imagePath: string) => {
    setOpenImage(true);
    setImagePath(imagePath);
  };
  const handleCloseImage = () => {
    setOpenImage(false);
  };

  const handleCloseConfirmationDelete = () => {
    setConfirmationDelete(false);
  };

  const handleConfirmSnackbar = (): void => {
    setOpenSnackbar(false);
  };

  const handleCloseSnackbar = (): void => {
    setOpenSnackbar(false);
  };

  const handleCreateSalesOrder = () => {
    setCart(null);
    history.push('/penjualan/tambah');
  };

  const handleChangeNavigation = (event: React.ChangeEvent<{}>, newValue: string) => {
    if (newValue.includes('salesOrder')) {
      history.push('/penjualan');
    } else if (newValue.includes('profile')) {
      setCurrentEditingUserProfileId(userProfileId);
      setOpenProfileModal(true);
    } else {
      setLogout(true);
    }
  };

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await axios.post(LOGOUT_URL);
    } catch (err) {
      console.log(err);
    }
    setLogout(false);
    unsetCurrentUser();
    history.push('/');
  };

  const handleRefresh = () => {
    setCurrentPage(1);
    setOrder('asc');
    setOrderBy('id');
    setName('');
    setSalesName('');
    setSalesOrderId('');
    setStatusOrder('PENDING');
    setHasFilter('PENDING');
    fetchData();
  };

  const handleOpenExport = () => {
    setOpenExport(true);
  };

  const handleCloseExport = () => {
    setOpenExport(false);
    clearExport();
  };

  const handleExport = async () => {
    const params = new URLSearchParams();

    if (date !== '') {
      params.append('date', format(new Date(date), 'yyyy-MM-dd'));
    }

    if (dateStart !== '') {
      params.append('dateStart', format(new Date(dateStart), 'yyyy-MM-dd'));
    }

    if (dateEnd !== '') {
      params.append('dateEnd', format(new Date(dateEnd), 'yyyy-MM-dd'));
    }

    if (zoneExport.length !== 0) {
      params.append('Zone', zoneExport.join(','));
    }

    if (status !== '') {
      params.append('status', status);
    }

    try {
      const { data } = await axios.get(`${SALES_ORDER_EXPORT_BASE_URL}?${params.toString()}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'sales-order.xlsx');
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.log('err', err);
    } finally {
      setOpenExport(false);
      clearExport();
    }
  };

  const clearExport = () => {
    setDate('');
    setDateStart('');
    setDateEnd('');
    setStatus('');
    setZoneExport([]);
  };

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const filterByAccess = () => {
    if (isAccess === TypeUser.PICKER) {
      const warehouseId = currentUser && currentUser.WareHouseId[0];
      const warehouse = currentUser && currentUser.WareHouseName[0].name;
      console.log('warehouse -->', warehouse);

      return salesOrders.filter(
        value =>
          value.progressItem &&
          value.progressItem
            .filter(value => value.WareHouseId == warehouseId)
            .some(
              value =>
                value.status === SalesOrderStatus.PENDING || value.status === SalesOrderStatus.PREVIEW || value.status === SalesOrderStatus.REJECT
            )
      );
    } else if (isAccess === TypeUser.ADMIN01) {
      const warehouseId = currentUser && currentUser.WareHouseId[0];
      return salesOrders.filter(
        value =>
          value.progressItem &&
          value.progressItem
            .filter(value => value.WareHouseId == warehouseId)
            .every(
              value =>
                value.status === SalesOrderStatus.PREVIEW || value.status === SalesOrderStatus.PACKING || value.status === SalesOrderStatus.REJECT
            )
      );
    } else if (isAccess === TypeUser.ADMIN02 || isAccess === TypeUser.ADMIN02PLUS) {
      const warehouseId = currentUser && currentUser.WareHouseId[0];
      return salesOrders.filter(
        value =>
          value.progressItem &&
          value.progressItem
            .filter(value => value.WareHouseId == warehouseId)
            .every(
              value =>
                value.status === SalesOrderStatus.PACKING ||
                value.status === SalesOrderStatus.CHECKING ||
                value.status === SalesOrderStatus.CONFIRM ||
                value.status === SalesOrderStatus.HAS_INVOICE ||
                value.status === SalesOrderStatus.REJECT
            )
      );
    } else {
      return salesOrders;
    }
  };

  const getData = async (id: number) => {
    if (salesOrders.some(value => value.SalesOrderItem && value.SalesOrderItem.some(value => value.SalesOrderId === id))) return false;

    setLoadingItem(true);

    try {
      const { data } = await axios.get(`${SALES_ORDER_BASE_URL}/${id}`);
      setSalesOrders(prevState =>
        prevState.map(value => {
          if (value.id === id) {
            value.SalesOrderItem = data.data.SalesOrderItem;
          }
          return value;
        })
      );
    } catch (err) {
      console.log('err', err);
    } finally {
      setLoadingItem(false);
    }
  };

  const handleOpenCollapse = (index: number, id: number): React.MouseEventHandler => () => {
    setIndexCollapse(index);
    setOpenCollapse(openCollapse ? (index === indexCollapse ? false : true) : true);
    getData(id);
  };

  const handleExpandMobile = (id: number, index: number) => {
    setIndexCollapse(index);
    getData(id);
  };

  const handleOpenConfirmation = () => {
    const so = salesOrders.find(value => value.id === selectedId);
    if (so && so.statusOrder !== 'CONFIRMATION') {
      deleteSalesOrder();
    } else {
      setOpenConfirmation(true);
    }
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };
  const openModalDiscount = (productName: string, totalQty: number, discount: number, totalDiscount: number) => {
    setOpenEdit(true);
    const newDiscount = {
      productName: productName,
      totalQty: totalQty,
      discount: discount,
      totalDiscount: totalDiscount
    };
    setDiscountResource({ ...newDiscount });
  };

  async function deleteSalesOrder() {
    if (!openConfirmation) {
      setLoadingDelete(true);
    }

    try {
      await axios.delete(`${SALES_ORDER_BASE_URL}/${selectedId}`);
      setSalesOrders(salesOrders.filter(value => value.id !== selectedId));
      setConfirmationDelete(false);

      handleSnackBar(true, 'success', 'Orderan berhasil dihapus.');
    } catch (err) {
      console.log(err);
      handleSnackBar(true, 'error', 'Orderan gagal dihapus.');
    } finally {
      setLoadingDelete(false);
    }
  }

  useEffect(() => {
    if (!name && !salesOrderId && !salesName && zone.length > 0) {
      return;
    }

    setCurrentPage(1);
  }, [name, salesOrderId, salesName, zone]);

  useEffect(() => {
    fecthZone();
  }, []);

  const debouncedFetchHits = useDebounced(fetchData, 500);
  const debouncedFetchTotalNominal = useDebounced(fetchTotalNominal, 500);

  useEffect(() => {
    debouncedFetchHits();
    return () => cancelToken.cancel('No longer latest query');
  }, [
    orderBy,
    order,
    currentPage,
    name,
    salesOrderId,
    salesName,
    statusOrder,
    zone,
    isSales,
    isSuperVisor,
    currentUser,
    startDate,
    endDate,
    isSuperAdmin,
    isAdmin,
    authorizaion
  ]);

  useEffect(() => {
    debouncedFetchTotalNominal();
    return () => cancelToken.cancel('No longer latest query');
  }, [name, salesOrderId, salesName, statusOrder, zone, isSales, isSuperVisor, currentUser, startDate, endDate, isSuperAdmin, isAdmin, authorizaion]);

  const getZone = () => {
    const list = salesOrders.map(val => val.zoneName);
    const unique = list.filter((value, index) => list.indexOf(value) === index);
    return unique;
  };

  const handleSearch = () => {
    if (/\d/.test(search)) {
      if (search.search('#') > -1) {
        setSalesOrderId(search.substring(1));
      } else {
        setSalesOrderId(search);
      }
    } else {
      setName(search);
    }
    setIsSearchFocus(false);
  };

  const handleKeywordClear = () => {
    setSearch('');
  };

  const handleKeyboardSearch = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleFilter = () => {
    if (hasFilter === 'asc' || hasFilter === 'desc') {
      setOrder(hasFilter);
    } else {
      setStatusOrder(hasFilter);
    }
    if (selectedOptions.length > 0) {
      setZone([...selectedOptions]);
      setSelectedOptions([]);
    }
    if (salesNameTemp !== '') {
      setSalesName(salesNameTemp);
    }
    setIsDrawerFilter(false);
  };

  const getTotalqty = (id: number) => {
    const total = salesOrders
      .filter(value => value.id === id)
      .map(
        value =>
          value.SalesOrderItem &&
          value.SalesOrderItem.filter(value => value.status !== SalesOrderStatus.REJECT)
            .map(value => value.totalItem)
            .reduce((total, newValue) => total + newValue, 0)
      );
    const { 0: totalQty } = total;
    return totalQty;
  };

  const getTotalHoldQty = (id: number) => {
    const total = salesOrders
      .filter(value => value.id === id)
      .map(value => value.SalesOrderItem && value.SalesOrderItem.map(value => value.holdStock).reduce((total, newValue) => total + newValue, 0));
    return Number(total);
  };

  const handleProgress = (id: number) => {
    if (isAccess === TypeUser.PICKER) {
      const isProgress = salesOrders
        .filter(value => value.id === id)
        .map(
          value =>
            value.progressItem &&
            value.progressItem
              .filter(value => value.WareHouseId == getWareHouse[0])
              .every(
                value =>
                  value.status === SalesOrderStatus.CONFIRM ||
                  value.status === SalesOrderStatus.HAS_INVOICE ||
                  value.status === SalesOrderStatus.CHECKING ||
                  value.status === SalesOrderStatus.PACKING ||
                  value.status === SalesOrderStatus.PREVIEW ||
                  value.status === SalesOrderStatus.REJECT
              )
        );
      const { 0: progress } = isProgress;
      return progress;
    } else if (isAccess === TypeUser.ADMIN01) {
      const isProgress = salesOrders
        .filter(value => value.id === id)
        .map(
          value =>
            value.progressItem &&
            value.progressItem
              .filter(value => value.WareHouseId == getWareHouse[0])
              .every(
                value =>
                  value.status === SalesOrderStatus.CONFIRM ||
                  value.status === SalesOrderStatus.HAS_INVOICE ||
                  value.status === SalesOrderStatus.CHECKING ||
                  value.status === SalesOrderStatus.PACKING ||
                  value.status === SalesOrderStatus.REJECT
              )
        );
      const { 0: progress } = isProgress;
      return progress;
    } else if (isAccess === TypeUser.ADMIN02) {
      const isProgress = salesOrders
        .filter(value => value.id === id)
        .map(
          value =>
            value.progressItem &&
            value.progressItem
              .filter(value => value.WareHouseId == getWareHouse[0])
              .every(
                value =>
                  value.status === SalesOrderStatus.CONFIRM ||
                  value.status === SalesOrderStatus.CHECKING ||
                  value.status === SalesOrderStatus.HAS_INVOICE ||
                  value.status === SalesOrderStatus.REJECT ||
                  value.status === SalesOrderStatus.HAS_INVOICE
              )
        );
      const { 0: progress } = isProgress;
      return progress;
    } else if (isAccess === TypeUser.ADMIN03) {
      const isProgress = salesOrders
        .filter(value => value.id === id)
        .map(
          value =>
            value.progressItem &&
            value.progressItem
              .filter(value => value.WareHouseId == getWareHouse[0])
              .every(value => value.status === SalesOrderStatus.CONFIRM || value.status === SalesOrderStatus.REJECT)
        );
      const { 0: progress } = isProgress;
      return progress;
    }
  };

  const getStatusItem = (id: number) => {
    if (isAccess !== TypeUser.ADMIN02) return false;
    const isStatus = salesOrders
      .filter(value => value.id === id)
      .map(
        value =>
          value.progressItem &&
          value.progressItem.filter(value => value.WareHouseId == getWareHouse[0]).some(value => value.status === SalesOrderStatus.CHECKING)
      );
    const { 0: status } = isStatus;

    return status;
  };

  const getItemProduct = (id: number) => {
    const totalProduct = salesOrders
      .filter(value => value.id === id)
      .map(
        value =>
          value.progressItem &&
          value.progressItem.filter(value => value.WareHouseId == getWareHouse[0] && value.status !== SalesOrderStatus.REJECT).length
      );

    return totalProduct[0];
  };

  const handleOpenAuthorization = () => {
    setAuthorizaion(true);
  };

  const handleCloseAuthorization = () => {
    setAuthorizaion(false);
  };

  const getNotif = async () => {
    try {
      const { data } = await axios.get(`${GET_NOTIF_DISCOUNT}?statusOrder=${statusOrder}`);

      if (data.data > 0) {
        setIsShown(true);
      }
      setTotalAuthorization(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNotif();
  }, [statusOrder]);
  console.log(totalNominal);
  return (
    <Page title='Sales Order'>
      <Container>
        <Grid container direction='row' spacing={2} className={classes.desktop}>
          <Grid item lg={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant='h1' component='h1'>
                Penjualan
              </Typography>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Breadcrumb />
            </Grid>
          </Grid>
          {(isSuperVisor || isSuperAdmin) && (
            <Grid item lg={9} md={12} sm={12} xs={12}>
              <CardTotal
                loading={isLoadingData}
                invoiceTotal={total}
                totalSo={totalNominal.totalSo}
                totalSoTerkonfirmasi={totalNominal.totalSoTerkonfirmasi}
                totalSoTertunda={totalNominal.totalSoTertunda}
                tagihanTotal={salesOrders.length > 0 ? salesOrders.map(val => val.totalPrice || 0).reduce((prev, curr) => prev + curr) : 0}
                rute={getZone().join(', ') || '-'}
                status={
                  statusOrder === ItemStatus.PENDING
                    ? 'Tertunda'
                    : statusOrder === 'CONFIRMATION'
                    ? 'Konfirmasi'
                    : statusOrder === 'CANCEL'
                    ? 'Batal'
                    : ''
                }
              />
            </Grid>
          )}
        </Grid>

        <Grid container direction='row' spacing={1} className={classes.desktop}>
          <PaperCustom>
            <Grid container direction='row' alignItems='center' item lg={12} md={12} sm={12} xs={12} spacing={2}>
              <Grid item xl={7} lg={7} md={12} sm={12} xs={12} container alignItems='center'>
                <Tooltip title='Memuat Ulang'>
                  <Button size='small' onClick={handleRefresh} color='inherit' className={classes.refresh}>
                    <RefreshIcon fontSize='small' />
                  </Button>
                </Tooltip>
                <Typography style={{ fontSize: '1rem', fontWeight: 400, marginLeft: '15px' }}>
                  {`Menampilkan ${total || 0} SO (${from || 0} - ${to || 0} dari ${total || 0})`}
                  {(isSuperAdmin || isAdmin) && (
                    <Typography color='primary'>
                      Data tanggal {format(new Date(startDate), 'dd-MM-yyyy')} s/d {format(new Date(endDate), 'dd-MM-yyyy')}
                    </Typography>
                  )}
                </Typography>
              </Grid>

              <Grid item xl={5} lg={5} md={12} sm={12} xs={12} container alignItems='center' justify='flex-end' style={{ columnGap: '1em' }}>
                {(isSuperAdmin || isAdmin) && (
                  <Tooltip title='Calendar filter' placement='top'>
                    <IconButton color='primary' aria-label='filter date' component='span' onClick={handleCalendarFilterClick}>
                      <Today />
                    </IconButton>
                  </Tooltip>
                )}
                {isAddAllowed && (
                  <Button onClick={handleCreateSalesOrder} size='small' disabled={isLoadingData}>
                    <AddBox fontSize='small' /> &nbsp; Order Penjualan
                  </Button>
                )}

                {isExportAllowed && (
                  <Button onClick={handleOpenExport} size='small' color='inherit'>
                    Export
                  </Button>
                )}
                {(isSuperAdmin || isAdmin) && !authorizaion && (
                  <Grid className={classes.containerNotification}>
                    <Badge
                      badgeContent={totalAuthorization}
                      color='error'
                      invisible={false}
                      style={{
                        position: 'absolute',
                        right: 5,
                        top: 5
                      }}
                    />

                    <Description
                      style={{ color: '#9F9F9F', fontSize: '2.1rem', cursor: 'pointer' }}
                      onClick={() => handleOpenAuthorization()}
                      className={totalAuthorization > 0 ? classes.animationNotif : ''}
                      onMouseEnter={() => setIsShown(true)}
                      onMouseLeave={() => setIsShown(false)}
                    />

                    {isShown && totalAuthorization > 0 && (
                      <>
                        <Grid className={classes.cardChild} />
                        <Grid className={classes.cardContainer}>
                          <Typography
                            style={{
                              color: 'white',
                              fontSize: '0.7rem'
                            }}
                          >
                            Mohon konfirmasi discount produk / plafon mitra ini
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}
                {(isSuperAdmin || isAdmin) && authorizaion && (
                  <Grid>
                    <IconButton color='primary' aria-label='back' component='span' className={classes.buttonBack}>
                      <ExitToApp fontSize='large' onClick={handleCloseAuthorization} />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
              <ModalDiscount
                isAccess={isAccess}
                discountResource={discountResource}
                openEdit={openEdit}
                showComponent={showComponent}
                setOpenEdit={setOpenEdit}
              />

              <Grid item sm={12} xs={12}>
                <SalesOrderTable
                  statusOrder={statusOrder}
                  isAccess={isAccess}
                  setStatusOrder={setStatusOrder}
                  salesOrderId={salesOrderId}
                  setSalesOrderId={setSalesOrderId}
                  handleOpenSO={handleOpenSO}
                  name={name}
                  openModalDiscount={openModalDiscount}
                  showComponent={showComponent}
                  setName={setName}
                  handleOpenImage={handleOpenImage}
                  salesName={salesName}
                  setSalesName={setSalesName}
                  zone={zone}
                  setZone={setZone}
                  zones={zones}
                  isLoadingData={isLoadingData}
                  salesOrders={salesOrders}
                  order={order}
                  orderBy={orderBy}
                  setOrder={setOrder}
                  setOrderBy={setOrderBy}
                  openCollapse={openCollapse}
                  indexCollapse={indexCollapse}
                  handleOpenCollapse={handleOpenCollapse}
                  handleConfirmationDelete={handleConfirmationDelete}
                  loadingItem={loadingItem}
                />
              </Grid>
              <Grid container item sm={12} xs={12} justify='flex-end'>
                <PaginationCustom
                  marginTop='-.4em '
                  show={salesOrders.length > 0}
                  sxPagination={{
                    count,
                    boundaryCount: 2,
                    variant: 'outlined',
                    shape: 'rounded',
                    onChange: (event, page) => {
                      setCurrentPage(page);
                    },
                    page: currentPage
                  }}
                  sxPopover={{
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'right'
                    },
                    transformOrigin: {
                      vertical: 'bottom',
                      horizontal: 'right'
                    }
                  }}
                  customPageProps={{
                    defaultValue: currentPage,
                    maxValue: count,
                    onSubmit(value) {
                      setCurrentPage(value);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </PaperCustom>
        </Grid>

        <ImageModal open={openImage} handleClose={handleCloseImage} imageUrl={imagePath} />

        <StandardConfirmationDialog
          variant={snackbarVariant}
          titleMessage={snackbarVariant === 'success' ? 'Success!' : 'Error!'}
          message={message}
          open={openSnackbar}
          handleClose={snackbarVariant === 'success' ? handleConfirmSnackbar : handleCloseSnackbar}
          noCancelButton={true}
        />

        <StandardConfirmationDialog
          variant={'danger'}
          titleMessage={'Delete'}
          message={'Apakah kamu yakin menghapus data ini?'}
          open={confirmationDelete}
          handleClose={handleCloseConfirmationDelete}
          onConfirm={handleOpenConfirmation}
          isLoading={loadingDelete}
        />

        <FormPinDialog
          open={openConfirmation}
          pinMessage={pinMessage}
          isComplete={isComplete}
          setComplete={setComplete}
          setPin={setPin}
          handleClose={handleCloseConfirmation}
        />

        <ExportModal
          openExport={openExport}
          date={date}
          dateStart={dateStart}
          dateEnd={dateEnd}
          status={status}
          zones={zones}
          zone={zoneExport}
          setZone={setZoneExport}
          setDate={setDate}
          setDateStart={setDateStart}
          setDateEnd={setDateEnd}
          setStatus={setStatus}
          handleClose={handleCloseExport}
          handleExport={handleExport}
        />

        {showComponent && (
          <Grid xs={12} container direction='column'>
            {isAccess === TypeUser.SUPERADMIN || isAccess === TypeUser.ADMIN ? (
              <Container>
                <Grid container direction='row' spacing={2}>
                  <Grid item lg={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant='h1' component='h1'>
                        Penjualan
                      </Typography>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Breadcrumb />
                    </Grid>
                  </Grid>
                  {isSuperAdmin && (
                    <Grid item lg={9} md={12} sm={12} xs={12}>
                      <CardTotal
                        loading={isLoadingData}
                        totalSo={totalNominal.totalSo}
                        totalSoTerkonfirmasi={totalNominal.totalSoTerkonfirmasi}
                        totalSoTertunda={totalNominal.totalSoTertunda}
                        invoiceTotal={salesOrders.length}
                        tagihanTotal={salesOrders.length > 0 ? salesOrders.map(val => val.totalPrice || 0).reduce((prev, curr) => prev + curr) : 0}
                        rute={getZone().join(', ') || '-'}
                        status={
                          statusOrder === ItemStatus.PENDING
                            ? 'Tertunda'
                            : statusOrder === 'CONFIRMATION'
                            ? 'Konfirmasi'
                            : statusOrder === 'CANCEL'
                            ? 'Batal'
                            : ''
                        }
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid container direction='row' spacing={1}>
                  <PaperCustom>
                    <Grid container direction='row' alignItems='center' item lg={12} md={12} sm={12} xs={12} spacing={2}>
                      <Grid item xl={7} lg={7} md={12} sm={12} xs={12} container alignItems='center'>
                        <Tooltip title='Memuat Ulang'>
                          <Button size='small' onClick={handleRefresh} color='inherit' className={classes.refresh}>
                            <RefreshIcon fontSize='small' />
                          </Button>
                        </Tooltip>
                        <Typography style={{ fontSize: '1rem', fontWeight: 400, marginLeft: '15px' }}>
                          {`Menampilkan ${total || 0} SO (${from || 0} - ${to || 0} dari ${total || 0})`}
                        </Typography>
                      </Grid>

                      <Grid item xl={5} lg={5} md={12} sm={12} xs={12} container alignItems='center' justify='flex-end'>
                        {isAddAllowed && (
                          <Button
                            onClick={handleCreateSalesOrder}
                            size='small'
                            disabled={isLoadingData}
                            style={{ marginLeft: isAddAllowed ? '2em' : '', marginRight: isAddAllowed ? '1em' : '' }}
                          >
                            <AddBox fontSize='small' /> &nbsp; Order Penjualan
                          </Button>
                        )}
                        {isExportAllowed && (
                          <Button onClick={handleOpenExport} size='small' color='inherit'>
                            Export
                          </Button>
                        )}
                        {(isSuperAdmin || isAdmin) && !authorizaion && (
                          <Grid className={classes.containerNotification}>
                            <Badge
                              badgeContent={totalAuthorization}
                              color='error'
                              invisible={false}
                              style={{
                                position: 'absolute',
                                right: 5,
                                top: 5
                              }}
                            />

                            <Description
                              style={{ color: '#9F9F9F', fontSize: '2.1rem', cursor: 'pointer' }}
                              onClick={() => handleOpenAuthorization()}
                              className={totalAuthorization > 0 ? classes.animationNotif : ''}
                              onMouseEnter={() => setIsShown(true)}
                              onMouseLeave={() => setIsShown(false)}
                            />

                            {isShown && totalAuthorization > 0 && (
                              <>
                                <Grid className={classes.cardChild} />
                                <Grid className={classes.cardContainer}>
                                  <Typography
                                    style={{
                                      color: 'white',
                                      fontSize: '0.7rem'
                                    }}
                                  >
                                    Mohon konfirmasi discount produk / plafon mitra ini
                                  </Typography>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        )}
                        {(isSuperAdmin || isAdmin) && authorizaion && (
                          <Grid>
                            <IconButton color='primary' aria-label='back' component='span' className={classes.buttonBack}>
                              <ExitToApp fontSize='large' onClick={handleCloseAuthorization} />
                            </IconButton>
                          </Grid>
                        )}
                      </Grid>
                      <ModalDiscount
                        isAccess={isAccess}
                        discountResource={discountResource}
                        openEdit={openEdit}
                        showComponent={showComponent}
                        setOpenEdit={setOpenEdit}
                      />

                      <Grid item sm={12} xs={12}>
                        <SalesOrderTable
                          statusOrder={statusOrder}
                          isAccess={isAccess}
                          setStatusOrder={setStatusOrder}
                          salesOrderId={salesOrderId}
                          setSalesOrderId={setSalesOrderId}
                          name={name}
                          openModalDiscount={openModalDiscount}
                          handleOpenSO={handleOpenSO}
                          showComponent={showComponent}
                          setName={setName}
                          handleOpenImage={handleOpenImage}
                          salesName={salesName}
                          setSalesName={setSalesName}
                          zone={zone}
                          setZone={setZone}
                          zones={zones}
                          isLoadingData={isLoadingData}
                          salesOrders={salesOrders}
                          order={order}
                          orderBy={orderBy}
                          setOrder={setOrder}
                          setOrderBy={setOrderBy}
                          openCollapse={openCollapse}
                          indexCollapse={indexCollapse}
                          handleOpenCollapse={handleOpenCollapse}
                          handleConfirmationDelete={handleConfirmationDelete}
                          loadingItem={loadingItem}
                        />
                      </Grid>
                      <Grid item sm={12} xs={12}>
                        {salesOrders.length > 0 && (
                          <Pagination
                            count={count}
                            onChange={(event, page) => setCurrentPage(page)}
                            page={currentPage}
                            boundaryCount={2}
                            variant='outlined'
                          />
                        )}
                      </Grid>
                    </Grid>
                  </PaperCustom>
                </Grid>
              </Container>
            ) : (
              <>
                <Grid xs={12} container justify='space-between' alignContent='flex-start'>
                  {isShow && (
                    <Grid xs={12} className={classes.topHeader} container alignItems='center'>
                      <Grid xs={3}>
                        <svg width='75' height='50' viewBox='0 0 93 34' fill='none' xmlns='http://www.w3.org/2000/svg' onClick={() => history.go(0)}>
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M19.7967 0V13.0658C19.7967 23.8899 10.9334 32.6645 0 32.6645L0 19.5987C0 8.77464 8.86327 0 19.7967 0Z'
                            fill='#D8D8D8'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M29.695 8.1323L25.2102 20.5776C21.4948 30.8875 10.2079 36.2034 0 32.4509L4.48483 20.0056C8.20018 9.69564 19.4872 4.37977 29.695 8.1323Z'
                            fill='#02A9EA'
                          />
                          <path
                            d='M55.192 19.672C55.224 19.464 55.304 19.312 55.432 19.216C55.576 19.104 55.728 19.048 55.888 19.048H57.832C58.008 19.048 58.16 19.112 58.288 19.24C58.432 19.352 58.496 19.504 58.48 19.696C58.432 20.352 58.264 21.008 57.976 21.664C57.704 22.32 57.28 22.912 56.704 23.44C56.128 23.968 55.4 24.4 54.52 24.736C53.64 25.072 52.576 25.24 51.328 25.24C50.224 25.24 49.248 25.08 48.4 24.76C47.552 24.424 46.832 23.968 46.24 23.392C45.648 22.8 45.184 22.096 44.848 21.28C44.528 20.464 44.336 19.576 44.272 18.616C44.24 18.008 44.224 17.336 44.224 16.6C44.224 15.864 44.24 15.192 44.272 14.584C44.336 13.624 44.528 12.736 44.848 11.92C45.184 11.104 45.648 10.408 46.24 9.832C46.832 9.24 47.552 8.784 48.4 8.464C49.248 8.128 50.224 7.96 51.328 7.96C52.576 7.96 53.64 8.128 54.52 8.464C55.4 8.8 56.128 9.232 56.704 9.76C57.28 10.288 57.704 10.888 57.976 11.56C58.264 12.216 58.432 12.864 58.48 13.504C58.496 13.696 58.432 13.856 58.288 13.984C58.16 14.096 58.008 14.152 57.832 14.152H55.888C55.728 14.152 55.576 14.104 55.432 14.008C55.288 13.896 55.2 13.736 55.168 13.528C55.12 13.208 55.008 12.896 54.832 12.592C54.656 12.288 54.416 12.016 54.112 11.776C53.808 11.536 53.424 11.344 52.96 11.2C52.496 11.04 51.952 10.96 51.328 10.96C50.704 10.96 50.16 11.056 49.696 11.248C49.232 11.44 48.84 11.696 48.52 12.016C48.216 12.336 47.976 12.72 47.8 13.168C47.64 13.616 47.544 14.088 47.512 14.584C47.48 15.192 47.464 15.864 47.464 16.6C47.464 17.336 47.48 18.008 47.512 18.616C47.544 19.128 47.64 19.608 47.8 20.056C47.976 20.488 48.216 20.864 48.52 21.184C48.84 21.504 49.232 21.76 49.696 21.952C50.16 22.144 50.704 22.24 51.328 22.24C51.952 22.24 52.496 22.168 52.96 22.024C53.424 21.864 53.808 21.664 54.112 21.424C54.432 21.184 54.68 20.912 54.856 20.608C55.032 20.304 55.144 19.992 55.192 19.672ZM71.5983 19.672C71.6303 19.464 71.7103 19.312 71.8383 19.216C71.9823 19.104 72.1343 19.048 72.2943 19.048H74.2383C74.4143 19.048 74.5663 19.112 74.6943 19.24C74.8383 19.352 74.9023 19.504 74.8863 19.696C74.8383 20.352 74.6703 21.008 74.3823 21.664C74.1103 22.32 73.6863 22.912 73.1103 23.44C72.5343 23.968 71.8063 24.4 70.9263 24.736C70.0463 25.072 68.9823 25.24 67.7343 25.24C66.6303 25.24 65.6543 25.08 64.8063 24.76C63.9583 24.424 63.2383 23.968 62.6463 23.392C62.0543 22.8 61.5903 22.096 61.2543 21.28C60.9343 20.464 60.7423 19.576 60.6783 18.616C60.6463 18.008 60.6303 17.336 60.6303 16.6C60.6303 15.864 60.6463 15.192 60.6783 14.584C60.7423 13.624 60.9343 12.736 61.2543 11.92C61.5903 11.104 62.0543 10.408 62.6463 9.832C63.2383 9.24 63.9583 8.784 64.8063 8.464C65.6543 8.128 66.6303 7.96 67.7343 7.96C68.9823 7.96 70.0463 8.128 70.9263 8.464C71.8063 8.8 72.5343 9.232 73.1103 9.76C73.6863 10.288 74.1103 10.888 74.3823 11.56C74.6703 12.216 74.8383 12.864 74.8863 13.504C74.9023 13.696 74.8383 13.856 74.6943 13.984C74.5663 14.096 74.4143 14.152 74.2383 14.152H72.2943C72.1343 14.152 71.9823 14.104 71.8383 14.008C71.6943 13.896 71.6063 13.736 71.5743 13.528C71.5263 13.208 71.4143 12.896 71.2383 12.592C71.0623 12.288 70.8223 12.016 70.5183 11.776C70.2143 11.536 69.8303 11.344 69.3663 11.2C68.9023 11.04 68.3583 10.96 67.7343 10.96C67.1103 10.96 66.5663 11.056 66.1023 11.248C65.6383 11.44 65.2463 11.696 64.9263 12.016C64.6223 12.336 64.3823 12.72 64.2063 13.168C64.0463 13.616 63.9503 14.088 63.9183 14.584C63.8863 15.192 63.8703 15.864 63.8703 16.6C63.8703 17.336 63.8863 18.008 63.9183 18.616C63.9503 19.128 64.0463 19.608 64.2063 20.056C64.3823 20.488 64.6223 20.864 64.9263 21.184C65.2463 21.504 65.6383 21.76 66.1023 21.952C66.5663 22.144 67.1103 22.24 67.7343 22.24C68.3583 22.24 68.9023 22.168 69.3663 22.024C69.8303 21.864 70.2143 21.664 70.5183 21.424C70.8383 21.184 71.0863 20.912 71.2623 20.608C71.4383 20.304 71.5503 19.992 71.5983 19.672ZM85.4164 8.2C85.6724 8.2 85.8644 8.272 85.9924 8.416C86.1204 8.544 86.2324 8.744 86.3284 9.016L92.2084 24.184C92.2244 24.232 92.2324 24.288 92.2324 24.352C92.2324 24.528 92.1684 24.68 92.0404 24.808C91.9124 24.936 91.7604 25 91.5844 25H89.8564C89.5364 25 89.3124 24.936 89.1844 24.808C89.0564 24.664 88.9684 24.528 88.9204 24.4L87.8884 21.736H80.3044L79.2724 24.4C79.2244 24.528 79.1364 24.664 79.0084 24.808C78.8804 24.936 78.6564 25 78.3364 25H76.6084C76.4324 25 76.2804 24.936 76.1524 24.808C76.0244 24.68 75.9604 24.528 75.9604 24.352C75.9604 24.288 75.9684 24.232 75.9844 24.184L81.8644 9.016C81.9604 8.744 82.0724 8.544 82.2004 8.416C82.3284 8.272 82.5204 8.2 82.7764 8.2H85.4164ZM86.7364 18.736L84.0964 11.896L81.4564 18.736H86.7364Z'
                            fill='#02A9EA'
                          />
                        </svg>
                      </Grid>
                      <Grid xs={9} className={clsx(isSearchFocus && classes.wrapperSearchFocus)}>
                        {isSearchFocus && <ArrowBackRounded onClick={() => setIsSearchFocus(false)} />}
                        <Grid xs={12} className={clsx(classes.inputContainer, isSearchFocus && classes.boxShadow)}>
                          <InputBase
                            classes={{
                              input: classes.textContentMobile
                            }}
                            fullWidth
                            placeholder='Cari nama atau no. order'
                            onKeyDown={handleKeyboardSearch}
                            onFocus={() => setIsSearchFocus(true)}
                            inputProps={{ 'aria-label': 'search' }}
                            startAdornment={
                              <Grid
                                className={clsx(classes.iconButton, classes.iconSearchButton)}
                                onClick={handleSearch}
                                container
                                justify='center'
                                alignItems='center'
                              >
                                <Search fontSize='small' />
                              </Grid>
                            }
                            endAdornment={
                              <Grid
                                className={clsx(classes.iconButton, classes.iconSearchButton)}
                                onClick={handleKeywordClear}
                                container
                                justify='center'
                                alignItems='center'
                              >
                                {search.length > 0 && <ClearRounded fontSize='small' />}
                              </Grid>
                            }
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {!isShow && <Typography className={classes.textHeaderMobile}>Penjualan</Typography>}
                </Grid>
                {!isShow && <Breadcrumb />}
                {isAccess === TypeUser.SUPERVISOR && (
                  <Grid xs={12}>
                    <Grid xs={12} container className={classes.containerBox}>
                      <Grid className={classes.containerBoxItem}>
                        <Typography>Jumlah Sales Order</Typography>
                        {isLoadingData ? (
                          <Skeleton variant='text' width='100%' height={30} />
                        ) : (
                          <Typography variant='h6'>{salesOrders.length}</Typography>
                        )}
                      </Grid>
                      <Grid className={classes.containerBoxItem}>
                        <Typography>Total Nominal SO</Typography>
                        {isLoadingData ? (
                          <Skeleton variant='text' width='100%' height={30} />
                        ) : (
                          <Typography variant='h6'>
                            {
                              <NumberFormat
                                value={salesOrders.map(val => val.totalPrice || 0).reduce((prev, curr) => prev + curr, 0)}
                                prefix={'Rp'}
                                thousandSeparator={true}
                                displayType='text'
                              />
                            }
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid xs={12} container className={classes.containerBox}>
                      <Grid className={classes.containerBoxItem}>
                        <Typography>Rute</Typography>
                        {isLoadingData ? (
                          <Skeleton variant='text' width='100%' height={30} />
                        ) : (
                          <Typography variant='h6'>{getZone().join(', ') || '-'}</Typography>
                        )}
                      </Grid>
                      <Grid className={classes.containerBoxItem}>
                        <Typography>Status SO</Typography>
                        {isLoadingData ? (
                          <Skeleton variant='text' width='100%' height={30} />
                        ) : (
                          <Typography variant='h6'>
                            {statusOrder === ItemStatus.PENDING
                              ? 'Tertunda'
                              : statusOrder === 'CONFIRMATION'
                              ? 'Konfirmasi'
                              : statusOrder === 'CANCEL'
                              ? 'Batal'
                              : ''}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {!isShow && (
                  <Paper className={classes.searchingContainer}>
                    <InputBase
                      classes={{
                        input: classes.textContentMobile
                      }}
                      style={{ flex: 1 }}
                      placeholder='Cari nama atau no. order'
                      onKeyDown={handleKeyboardSearch}
                      inputProps={{ 'aria-label': 'search' }}
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />

                    <IconButton type='submit' className={classes.iconButton} aria-label='search' onClick={handleSearch}>
                      <Search fontSize='small' />
                    </IconButton>
                  </Paper>
                )}
                {allowAuthorisation.includes(isAccess) && (
                  <Grid className={classes.containerAutoratation} xs={12}>
                    <Button variant='outlined' fullWidth onClick={() => setShowAuthorisation(true)}>
                      Lihat SO Pending Plafon & Discount ({totalAuthorization})
                    </Button>
                  </Grid>
                )}

                <Paper className={clsx(isShow ? classes.wrapperMobile : classes.containerMobile)}>
                  <Grid xs={12} container direction='row' alignItems='center' justify='space-between'>
                    <Typography className={classes.textContentBoldMobile} style={{ flexGrow: 1 }}>
                      {`Menampilkan ${filterByAccess().length} SO (1 - ${filterByAccess().length} dari ${filterByAccess().length})`}
                    </Typography>

                    <Grid className={classes.iconRefreshButton} onClick={handleRefresh}>
                      <Refresh style={{ fontSize: 20 }} />
                    </Grid>

                    <TuneRounded onClick={() => setIsDrawerFilter(true)} />

                    <Grid xs={12} container justify='flex-end' className={classes.spacing}>
                      {salesOrders.length > 0 && (
                        <Pagination
                          count={count}
                          onChange={(event, page) => setCurrentPage(page)}
                          page={currentPage}
                          boundaryCount={2}
                          variant='outlined'
                          shape='rounded'
                          color='primary'
                          size='small'
                        />
                      )}
                    </Grid>
                    <Grid xs={12} className={classes.sectionContentMobile}>
                      {isLoadingData
                        ? [0, 1, 2, 3, 4, 5].map(val => (
                            <CardMobile
                              noOrder='#'
                              key={val}
                              id={val}
                              idClick={indexCollapse}
                              customerName='#'
                              handleExpandMobile={() => console.log('dummy')}
                              dateOrder='#'
                              onClick={() => console.log('dummy')}
                              loadingItem={loadingItem}
                              isHasInvoice={false}
                              isLoading={isLoadingData}
                              statsOrder='#'
                              isDone={false}
                              isAccess={isAccess}
                              totalItem={23}
                              totalQty={12}
                            />
                          ))
                        : isAccess === TypeUser.SALES || isAccess === TypeUser.SUPERVISOR
                        ? salesOrders.map((value, key) => (
                            <CardMobile
                              id={key}
                              noOrder={value.orderNumber}
                              idClick={indexCollapse}
                              onClick={() => handleOpenSO(value.id)}
                              customerName={value.partnerName || '-'}
                              dateOrder={format(new Date(value.orderDate), 'dd MMM yyyy')}
                              isLoading={isLoadingData}
                              loadingItem={loadingItem}
                              isHasInvoice={getStatusItem(value.id)}
                              statsOrder={value.statusOrder}
                              isAccess={isAccess}
                              salesName={value.salesName}
                              isDone={false}
                              handleExpandMobile={() => handleExpandMobile(value.id, key)}
                              totalItem={value.totalItem}
                              rute={value.zoneName}
                              nominalSO={value.totalPrice}
                              totalQty={getTotalqty(value.id) || 0}
                              qtyStuck={getTotalHoldQty(value.id) || 0}
                            />
                          ))
                        : isAccess === TypeUser.ADMIN03
                        ? salesOrders.map((value, key) => (
                            <CardMobile
                              id={key}
                              noOrder={value.orderNumber}
                              idClick={indexCollapse}
                              handleExpandMobile={() => handleExpandMobile(value.id, key)}
                              onClick={() => history.push(`/penjualan/${value.id}`)}
                              customerName={value.partnerName || '-'}
                              dateOrder={format(new Date(value.orderDate), 'dd MMM yyyy')}
                              isLoading={isLoadingData}
                              loadingItem={loadingItem}
                              isHasInvoice={getStatusItem(value.id)}
                              isDone={handleProgress(value.id)}
                              statsOrder={value.statusOrder}
                              isAccess={isAccess}
                              totalItem={value.totalItem}
                              totalQty={getTotalqty(value.id) || 0}
                              discount={value.totalDiscount}
                              totalPrice={value.totalPrice}
                            />
                          ))
                        : isAccess === TypeUser.ADMIN02 || isAccess === TypeUser.ADMIN02PLUS
                        ? filterByAccess().map((value, key) => (
                            <CardMobile
                              id={key}
                              noOrder={value.orderNumber}
                              idClick={indexCollapse}
                              handleExpandMobile={() => handleExpandMobile(value.id, key)}
                              onClick={() => handleOpenSO(value.id)}
                              customerName={value.partnerName || '-'}
                              isHasInvoice={getStatusItem(value.id)}
                              dateOrder={format(new Date(value.orderDate), 'dd MMM yyyy')}
                              isLoading={isLoadingData}
                              loadingItem={loadingItem}
                              rute={value.zoneName}
                              isOpen={
                                (user &&
                                  (value.isOpeWareHouse === (user && user.WareHouseName[0].name) || '') &&
                                  (value.isOpen !== (user && user.id) || 0)) ||
                                undefined
                              }
                              isDone={handleProgress(value.id)}
                              statsOrder={value.statusOrder}
                              isAccess={isAccess}
                              totalItem={getItemProduct(value.id)}
                              totalQty={getTotalqty(value.id) || 0}
                            />
                          ))
                        : isAccess === TypeUser.ADMIN01
                        ? filterByAccess().map((value, key) => (
                            <CardMobile
                              id={key}
                              noOrder={value.orderNumber}
                              idClick={indexCollapse}
                              handleExpandMobile={() => handleExpandMobile(value.id, key)}
                              onClick={() => history.push(`/penjualan/${value.id}`)}
                              customerName={value.partnerName || '-'}
                              isHasInvoice={getStatusItem(value.id)}
                              dateOrder={format(new Date(value.orderDate), 'dd MMM yyyy')}
                              isLoading={isLoadingData}
                              rute={value.zoneName}
                              statsOrder={value.statusOrder}
                              isDone={handleProgress(value.id)}
                              loadingItem={loadingItem}
                              isAccess={isAccess}
                              totalItem={getItemProduct(value.id)}
                              totalQty={getTotalqty(value.id) || 0}
                            />
                          ))
                        : isAccess === TypeUser.PICKER || isAccess === TypeUser.HEAD_ADMIN_OPS
                        ? filterByAccess().map((value, key) => (
                            <CardMobile
                              id={key}
                              noOrder={value.orderNumber}
                              idClick={indexCollapse}
                              handleExpandMobile={() => {
                                handleExpandMobile(value.id, key);
                                setIdClick(value.id);
                              }}
                              onClick={() => history.push(`/penjualan/${value.id}`)}
                              customerName={value.partnerName || '-'}
                              dateOrder={format(new Date(value.orderDate), 'dd MMM yyyy')}
                              isLoading={isLoadingData}
                              loadingItem={loadingItem}
                              isHasInvoice={getStatusItem(value.id)}
                              progress={value.progressItem}
                              salesName={value.salesName}
                              rute={value.zoneName}
                              isOpen={!!value.isOpen}
                              isDone={handleProgress(value.id)}
                              statsOrder={value.statusOrder}
                              isAccess={isAccess}
                              totalItem={
                                (value.progressItem && value.progressItem.filter(value => value.status !== SalesOrderStatus.REJECT).length) || 0
                              }
                              totalQty={getTotalqty(value.id) || 0}
                            />
                          ))
                        : null}
                    </Grid>
                    <Zoom in={trigger}>
                      <Grid className={classes.ArrowUp} onClick={handleScrollTop} style={{ bottom: isSuperVisor || isSales ? 90 : 70 }}>
                        <ArrowUpwardRounded fontSize='small' className={classes.iconButton} />
                      </Grid>
                    </Zoom>

                    {(isSuperVisor || isSales) && (
                      <Grid onClick={handleCreateSalesOrder} className={classes.AddShoppingCartWrapper}>
                        <AddShoppingCartRounded className={classes.AddShoppingCartIcon} fontSize='large' />
                      </Grid>
                    )}

                    <AuthorisationList
                      open={showAuthorisation}
                      search={keywordAuthorisation}
                      setSearch={setKeywordAuthorisation}
                      setOpen={setShowAuthorisation}
                      authorisations={authorisations}
                      metaAuthorisation={metaAuthorisation}
                      isLoading={loadingAuthorisation}
                      handleSearchAuthorisation={handleSearchAuthorisation}
                    />
                  </Grid>
                </Paper>
              </>
            )}
            {isShow && (
              <>
                <Grid xs={12} className={classes.navigationWrapper}>
                  <BottomNavigation value={'salesOrder'} onChange={handleChangeNavigation} className={classes.buttomNavigation}>
                    <BottomNavigationAction showLabel label='Sales Order' value='salesOrder' icon={<ShoppingCartRounded />} />
                    <BottomNavigationAction showLabel label='Profile' value='profile' icon={<PersonRounded />} />
                    <BottomNavigationAction showLabel label='Keluar' value='exit' icon={<ExitToAppRounded />} />
                  </BottomNavigation>
                </Grid>
                <UpdateProfileModal
                  open={openProfileModal || isNew}
                  userId={currentEditingUserProfileId}
                  user={user}
                  isNew={isNew}
                  isSales={type === TypeUser.SALES}
                  handleCancel={handleCancelProfileModal}
                  setOpenSnackbar={setOpenSnackbar}
                  setSnackbarVarient={setSnackbarVarient}
                />

                <StandardConfirmationDialog
                  variant='logout'
                  titleMessage='Log Out'
                  message='Apakah yakin anda ingin keluar ?'
                  open={openLogout}
                  isLoading={isLoading}
                  handleClose={() => setLogout(false)}
                  onConfirm={handleLogout}
                />
              </>
            )}
          </Grid>
        )}

        <DateRangeFilter
          openCalendarFilter={openCalendarFilter}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          handleClose={() => setOpenCalendarFilter(false)}
        />

        <Drawer anchor='right' open={isDrawerFilter}>
          <DrawerFilter
            setOpen={setIsDrawerFilter}
            hasFilter={hasFilter}
            setSelectedOptions={setSelectedOptions}
            selectedOptions={selectedOptions}
            setSalesName={setSalesNameTemp}
            salesName={salesNameTemp}
            zones={zones}
            setHasFilter={setHasFilter}
            handleFilter={handleFilter}
            isAccess={isAccess}
          />
        </Drawer>
      </Container>
    </Page>
  );
};

export default SalesOrderPage;
